import {Contacto} from '../contacto.model';
import {BaseModel} from '../../../shared';

export class Empresa extends BaseModel {
  empresaId: string;
  tipoSocialId: string;
  tipoSocialDescripcion: string;
  empresaPersonaCi: string;
  empresaRazonSocial: string;
  empresaRut: string;
  contactos: Contacto[] = [];
  name(){
    return `${this.empresaRazonSocial}`;
  }
}
